export const queryReferralEligibilityResults = `
query GetReferral($id: ID!) {
  getReferral(id: $id) {
	eligibilityResults
  }
}
`;
